import { ActionBase } from '../../../core/store/action/ActionBase';
import { ExtractModel } from "../../models/ExtractModel";

export const SET_SELECTED_EXTRACT_MODEL = '[Extract] Set Selected Extract Model';

export class SetSelectedExtractModelAction implements ActionBase {
  readonly identifier = new Date().getTime().toString();
  readonly type = SET_SELECTED_EXTRACT_MODEL;

  constructor ( public payload: { model: ExtractModel }) {}
}



// WEBPACK FOOTER //
// ./src/app/extracts/store/actions/SetSelectedExtractModelAction.ts